import { Injectable } from '@angular/core';
import { Rpfi13DayRow, Rpfi13PosGroup, Rpfi13TableResult, Rpfi13Totals } from '../../models/report/rpfi13.model';

@Injectable({ providedIn: 'root' })
export class MapperRpfi13Service {
  mapTable(res: unknown): Rpfi13TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      groups: groups.map((g) => this.mapGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapGroup(dto: unknown): Rpfi13PosGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const rows = (g['rows'] ?? g['Rows'] ?? []) as unknown[];
    return {
      posName: String(g['posName'] ?? g['PosName'] ?? ''),
      rows: rows.map((r) => this.mapRow(r)),
      sumCount: Number(g['sumCount'] ?? g['SumCount'] ?? 0),
      sumCash: Number(g['sumCash'] ?? g['SumCash'] ?? 0),
      sumQr: Number(g['sumQr'] ?? g['SumQr'] ?? 0),
      sumTransfer: Number(g['sumTransfer'] ?? g['SumTransfer'] ?? 0),
      sumDiscount: Number(g['sumDiscount'] ?? g['SumDiscount'] ?? 0),
      sumOther: Number(g['sumOther'] ?? g['SumOther'] ?? 0),
      sumTotal: Number(g['sumTotal'] ?? g['SumTotal'] ?? 0),
    };
  }

  private mapRow(dto: unknown): Rpfi13DayRow {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(r['seq'] ?? r['Seq'] ?? 0),
      paidDate: (r['paidDate'] ?? r['PaidDate'] ?? null) as string | null,
      receiptStart: String(r['receiptStart'] ?? r['ReceiptStart'] ?? ''),
      receiptEnd: String(r['receiptEnd'] ?? r['ReceiptEnd'] ?? ''),
      count: Number(r['count'] ?? r['Count'] ?? 0),
      cash: Number(r['cash'] ?? r['Cash'] ?? 0),
      qr: Number(r['qr'] ?? r['Qr'] ?? 0),
      transfer: Number(r['transfer'] ?? r['Transfer'] ?? 0),
      discount: Number(r['discount'] ?? r['Discount'] ?? 0),
      other: Number(r['other'] ?? r['Other'] ?? 0),
      total: Number(r['total'] ?? r['Total'] ?? 0),
    };
  }

  private mapTotals(dto: unknown): Rpfi13Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      rowCount: Number(t['rowCount'] ?? t['RowCount'] ?? 0),
      sumCount: Number(t['sumCount'] ?? t['SumCount'] ?? 0),
      sumCash: Number(t['sumCash'] ?? t['SumCash'] ?? 0),
      sumQr: Number(t['sumQr'] ?? t['SumQr'] ?? 0),
      sumTransfer: Number(t['sumTransfer'] ?? t['SumTransfer'] ?? 0),
      sumDiscount: Number(t['sumDiscount'] ?? t['SumDiscount'] ?? 0),
      sumOther: Number(t['sumOther'] ?? t['SumOther'] ?? 0),
      sumTotal: Number(t['sumTotal'] ?? t['SumTotal'] ?? 0),
    };
  }
}
